// Journal Types Configuration
export const JOURNAL_TYPES = {
  editorialNote: {
    key: 'editorialNote',
    displayName: 'EDITORIAL',
    label: 'Editorial Note',
    order: 1
  },
  philosophicalInsights: {
    key: 'philosophicalInsights',
    displayName: 'PHILOSOPHICAL INSIGHTS',
    label: 'Philosophical Insights',
    order: 2
  },
  originalArticles: {
    key: 'originalArticles',
    displayName: 'ORIGINAL ARTICLES',
    label: 'Original Articles',
    order: 3
  },
  reviewArticles: {
    key: 'reviewArticles',
    displayName: 'REVIEW ARTICLES',
    label: 'Review Articles',
    order: 4
  },
  caseReports: {
    key: 'caseReports',
    displayName: 'CASE STUDIES',
    label: 'Case Studies',
    order: 5
  },
  seminarReport: {
    key: 'seminarReport',
    displayName: 'SEMINAR REPORT',
    label: 'Seminar Report',
    order: 6
  }
};

// Helper functions
export const getJournalTypeByKey = (key) => {
  return JOURNAL_TYPES[key] || null;
};

export const getJournalTypeDisplayName = (key) => {
  return JOURNAL_TYPES[key]?.displayName || key;
};

export const getJournalTypeLabel = (key) => {
  return JOURNAL_TYPES[key]?.label || key;
};

export const getAllJournalTypes = () => {
  return Object.values(JOURNAL_TYPES).sort((a, b) => a.order - b.order);
};

export const getJournalTypeKeys = () => {
  return Object.keys(JOURNAL_TYPES);
};

// For admin dropdown options
export const getJournalTypeOptions = () => {
  return getAllJournalTypes().map(type => ({
    value: type.key,
    label: type.label
  }));
}; 